import * as React from 'react'

function Cross(props) {
    return (
        <svg
            width={16}
            height={15}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.102.22a.75.75 0 011.061 1.06L9.002 7.441l6.161 6.161a.75.75 0 01-1.06 1.061L7.94 8.503l-6.16 6.16a.75.75 0 11-1.061-1.06L6.88 7.44.72 1.281A.75.75 0 111.78.22l6.161 6.16L14.102.22z"
                fill="#fff"
            />
        </svg>
    )
}

export default Cross
